export enum FMItemTypes {
  file = 'FILE',
  directory = 'DIRECTORY',
}

export enum FMPlacedInsideTypes {
  page = 'page',
  modal = 'modal',
}

export enum FMStoragesTypes {
  media = 'media',
  static = 'static',
}

export enum FMFilePropToUseTypes {
  url = 'url',
  path = 'path',
}

export enum FMFileUrlTypes {
  regular = 'regular',
  downloadable = 'downloadable',
}

export enum NotificationsTypes {
  success = 'success',
  error = 'error',
  info = 'info',
  warning = 'warning'
}

export enum UnitsTypes {
  in = 'in',
  cm = 'cm',
  mm = 'mm'
}

export enum SOMTypes {
  standard = 'Standard',
  metric = 'Metric',
}

export enum AuthFormTypes {
  SIGN_IN = 'Sign in',
  SIGN_UP = 'Sign up',
  FORGOT_PASSWORD = 'Get reset link',
  RESET_PASSWORD = 'Reset password',
  SIGN_OUT = 'Sign out',
  PASSWORD_PROTECTED = 'Submit',
}
